var _filter, _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClearRowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "9pt",
    height: "9pt",
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 9,
    height: 9,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface7",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.45098%,90.980392%,95.294118%)",
      fillOpacity: 1
    },
    d: "M 4.667969 4.253906 L 7.921875 1 C 7.996094 0.925781 8.027344 0.816406 8 0.714844 C 7.976562 0.609375 7.894531 0.53125 7.792969 0.503906 C 7.6875 0.476562 7.582031 0.507812 7.507812 0.585938 L 4.253906 3.839844 L 1 0.585938 C 0.882812 0.488281 0.710938 0.492188 0.601562 0.601562 C 0.492188 0.710938 0.488281 0.882812 0.585938 1 L 3.839844 4.253906 L 0.585938 7.507812 C 0.472656 7.621094 0.476562 7.804688 0.589844 7.917969 C 0.703125 8.03125 0.886719 8.03125 1 7.921875 L 4.253906 4.667969 L 7.507812 7.921875 C 7.582031 8 7.691406 8.027344 7.792969 8.003906 C 7.894531 7.976562 7.976562 7.894531 8.003906 7.792969 C 8.027344 7.691406 8 7.582031 7.921875 7.507812 Z M 4.667969 4.253906 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface7",
    mask: "url(#mask0)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearRowIcon);
export default __webpack_public_path__ + "static/media/clear-row-icon.d73dd324fc3af8722e7fd0da7bb09d22.svg";
export { ForwardRef as ReactComponent };